import { Stack } from '@tumelo/designsystem'
import { SWRUnwrapper } from '@tumelo/data-fetching'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'
import styled from 'styled-components'
import { useFetchUserDetails } from '../../../application/hooks/useFetchUserDetails'
import { getCurrentSlug } from '../../../utils/getCurrentSlug'
import { AvatarWithInitials } from '../../AvatarWithInitials'

export const HeaderProfile: React.FC = () => {
  const userDetailsResponse = useFetchUserDetails()
  const router = useRouter()
  const currentSlug = getCurrentSlug(router)

  return (
    <StyledContainer>
      <Stack flexDirection="row" gap="0.8rem">
        <SWRUnwrapper
          response={userDetailsResponse}
          loadingComponent={<AvatarWithInitials firstName="" lastName="" />}
          errorComponent={<AvatarWithInitials firstName="" lastName="" />}
        >
          {(user) => (
            <Link href={`${currentSlug}/profile`}>
              <AvatarWithInitials firstName={user ? user.firstName : ''} lastName={user ? user.lastName : ''} />
            </Link>
          )}
        </SWRUnwrapper>
      </Stack>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  position: relative;
`
